import { ModalWrapper } from 'src/components/modal-wrapper'
import { useStyles } from './styes'
import { Button, useMediaQuery, useTheme } from '@mui/material'
import { useRedirectURLDelete } from 'src/hooks/redirect-urls/use-delete-redirect-url.hook'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
    modalOpen: boolean
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
    id: string,
}

export const ConfirmDeleteModal = ({modalOpen, setModalOpen, id}: IProps) => {
    const {mutate} = useRedirectURLDelete()
    const style = useStyles()
    const theme = useTheme()
    const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

    const handleSubmit = () => {
        mutate(id)
      return setModalOpen(false)
    } 

    return (
    <ModalWrapper 
        open={modalOpen} 
        onClose={() => setModalOpen(false)} 
        className={isTablet ? style.ownerInputModalTabletDelete : style.ownerInputModalDelete}
    >
        <div className={isTablet ? style.modalTabletDelete : style.modalDelete}>
            <h3><HelperWrapper t='delete-modal-text-submit'/></h3>
            <Button onClick={handleSubmit} color='error'><HelperWrapper t='delete-button-text'/></Button> 
        </div>
        
    </ModalWrapper>
  )
}
